import { useCallback, useLayoutEffect, useRef, useState } from 'react'

/**
 * Хук для управления и отслеживания высоты контейнера.
 *
 * @param defaultHeight - Начальное значение высоты до измерения контейнера.
 * @returns Объект с полями:
 *   - `ref`: React ref, который нужно прикрепить к контейнеру.
 *   - `containerHeight`: Текущая высота контейнера.
 *   - `updateHeight`: Функция для ручного обновления высоты.
 *
 * Хук автоматически обновляет высоту контейнера при изменении размера окна.
 */
export function useContainerHeight(defaultHeight: number) {
  const ref = useRef<HTMLDivElement>(null)
  const [containerHeight, setContainerHeight] = useState(defaultHeight)

  const updateHeight = useCallback(() => {
    if (ref.current) {
      setContainerHeight(ref.current.offsetHeight)
    }
  }, [])

  useLayoutEffect(() => {
    updateHeight()
    window.addEventListener('resize', updateHeight)
    return () => window.removeEventListener('resize', updateHeight)
  }, [updateHeight])

  return { ref, containerHeight, updateHeight }
}
